import Box from '@mui/material/Box';
import { alpha, useTheme } from '@mui/material/styles';

export const JAIPUR_SKYLINE_IMAGE = '/images/d5570d79-908c-4828-97af-bcb2d8a0ea34.png';

export function AuthPageFooter() {
  const theme = useTheme();
  const cream = theme.palette.background.default;

  return (
    <Box
      component="footer"
      aria-hidden
      sx={{
        flexShrink: 0,
        position: 'relative',
        width: '100%',
        height: { xs: '24svh', sm: '26svh', md: '28svh' },
        minHeight: { xs: 140, sm: 170, md: 210 },
        maxHeight: { xs: 220, sm: 250, md: 300 },
        overflow: 'hidden',
        lineHeight: 0,
        bgcolor: theme.palette.secondary.light,
      }}
    >
      <Box
        component="img"
        src={JAIPUR_SKYLINE_IMAGE}
        alt=""
        sx={{
          width: '100%',
          height: '115%',
          objectFit: 'cover',
          objectPosition: 'center 100%',
          transform: 'translateY(8%)',
          display: 'block',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: `linear-gradient(
            180deg,
            ${cream} 0%,
            ${alpha(cream, 0.85)} 18%,
            ${alpha(cream, 0.35)} 38%,
            transparent 62%
          )`,
        }}
      />
    </Box>
  );
}
